import React from "react";
import { NWSSkeletonLoader } from "@nws/nws-ui-library";

export const LoadingSkeleton = ({ width = "200px" }) => (
  <NWSSkeletonLoader type="inline" width={width} />
);
